import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import withOptions from 'utils/functions/withOptions.util';
import actionBe from 'utils/mw/actionBe.util';

const beFetchStylistStripeDashboard = actionBe(
  'beFetchStylistStripeDashboard',
  withOptions(({ AT, ATAG, stylistId }) =>
    endpoint(H.get, 'ncob/checkout/salon/stripe/dashboard/:salonId/:stylistId/', {
      AT,
      name: ATAG,
      params: { stylistId },
    }),
  ),
);

// noinspection JSUnusedGlobalSymbols
export default beFetchStylistStripeDashboard;
